import { FC } from 'react';
import { HexColorPicker } from 'react-colorful';
import { ColorPickerBaseProps } from 'react-colorful/dist/types';
import './style.scss';

const Colorful: FC<ColorPickerBaseProps<string>> = ({ color, onChange, ...props }: ColorPickerBaseProps<string>): JSX.Element => {
  return (
    <div className="colorful">
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <HexColorPicker {...props} color={color} onChange={onChange} />
    </div>
  );
};

export default Colorful;
